<template>
    <div class="wrapper">
        <loader></loader>
        <pwa-update></pwa-update>
        <notifications></notifications>
        <side-menu></side-menu>
        <div class="main-content">
            <page-content></page-content>
        </div>
    </div>
</template>

<script>
    /* eslint-disable no-new */
    import PerfectScrollbar from 'perfect-scrollbar';
    import 'perfect-scrollbar/css/perfect-scrollbar.css';
    import PwaUpdate from '../pwa/components/PwaUpdate'

    function hasElement(className) {
        return document.getElementsByClassName(className).length > 0;
    }

    function initScrollbar(className) {
        if (hasElement(className)) {
            new PerfectScrollbar(`.${className}`);
        } else {
            // try to init it later in case this component is loaded async
            setTimeout(() => {
                initScrollbar(className);
            }, 100);
        }
    }

    import SideMenu from './parts/SideMenu';
    import PageContent from './parts/Content';

    export default {
        
        components: {
            SideMenu, PageContent, PwaUpdate
        },

        mounted() {
            this.initScrollbar()
        },

        methods: {
            initScrollbar() {
                let isWindows = navigator.platform.startsWith('Win');
                if (isWindows) {
                    initScrollbar('sidenav');
                }
            }

        }
    };
</script>

<style>

    body {
        min-height: 100vh;
    }

</style>
